import type { SuppliesProduct } from '../../pages/supplies-page/api/fetch-products';

export const REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS = 'REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS';
type RequestGetSuppliesProductsSuccessAction = {
  type: typeof REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS;
  products: SuppliesProduct[];
};
export const requestGetSuppliesProductsSuccess = (products: SuppliesProduct[]): RequestGetSuppliesProductsSuccessAction => ({
  type: REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS,
  products,
});

export const REQUEST_GET_SUPPLIES_PRODUCTS_ERROR = 'REQUEST_GET_SUPPLIES_PRODUCTS_ERROR';
type RequestGetSuppliesProductsErrorAction = {
  type: typeof REQUEST_GET_SUPPLIES_PRODUCTS_ERROR;
  error: string;
};
export const requestGetSuppliesProductsError = (error: string): RequestGetSuppliesProductsErrorAction => ({
  type: REQUEST_GET_SUPPLIES_PRODUCTS_ERROR,
  error,
});

export type SuppliesAction = RequestGetSuppliesProductsSuccessAction | RequestGetSuppliesProductsErrorAction;
